import { CRON_EXECUTED } from './types';

export default {
  async [CRON_EXECUTED](state, payload) {
    state.cronData = payload;
  }
};
